const StudentStatuses = Object.freeze({
  PreRegistro: 'Pre-Registro',
  Registro: 'Registro',
  Evaluado: 'Evaluado',
  Servido: 'Servido',
  NoElegible: 'No Elegible',
  Egreso: 'Egreso',
  Disponible: 'Disponible',
  Inactivo: 'Inactivo',
  Elegible: 'Elegible',
});

export default StudentStatuses;
